import { Box, Stack, Skeleton, styled } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';

export const MetadataSkeleton = () => {
  const animate = 'wave';
  return (
    <Box sx={{ width: '100%', p: 2, pt: 4 }}>
      <Stack spacing={4} direction="column">
        <StyledSkeleton variant="rectangular" animation={animate} width={'100%'} height={48} />
        <StyledSkeleton variant="rectangular" animation={animate} width={'100%'} height={240} />
      </Stack>
    </Box>
  );
};

const StyledSkeleton = styled(Skeleton)({
  background: colors.grey[100],
});
